import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';
import { ProjectTable } from './list/components';

export default function ProjectsPage() {
  const queryClient = new QueryClient();
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Helmet>
          <title> Projects </title>
        </Helmet>
        <ProjectTable />
      </QueryClientProvider>
    </>
  );
}
